import { render } from "./Contacts2.vue?vue&type=template&id=49cd38c6&scoped=true"
import script from "./Contacts2.vue?vue&type=script&lang=js"
export * from "./Contacts2.vue?vue&type=script&lang=js"

import "./Contacts2.vue?vue&type=style&index=0&id=49cd38c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49cd38c6"]])

export default __exports__